export default __webpack_public_path__ + "static/media/logo.d74b43a8.svg";